const firebase = require('gatsby-plugin-firebase');

exports.firebase = firebase;
